export default __webpack_public_path__ + "static/media/fb.4f84c77d.svg";